/**
 * @typedef {(id: string) => JSX.Element} Callback
 * @typedef {string | JSX.Element | number | null | string[] | boolean} Data
 * @typedef {{data: Data, index?: string}} Response
 * @typedef {import('../../OfferService/OfferFields').default} OfferFields
 * @typedef {import('./Props').default} Props
 */

import { translate } from '../../../Internationalization';
import categoryList from '@mooveguru/yhh-shared-config/marketplace-categories.json';
import { parsePostalCodeList } from '../../../../utils/postalCodes';

/**
 * @param {OfferFields[]} vendors
 * @param {Callback} callback
 * @returns {Response[][]}
 */
export default function getVendorsTableData(vendors, callback) {
	return vendors.map((value, index) => mapData(value, index, callback));
}

/**
 * @param {OfferFields} value
 * @param {number} index
 * @param {Callback} callback
 * @returns {Response[]}
 */
function mapData(value, index, callback) {
	const status = value.status ? 'active' : 'disabled';

	return [
		tableCell(value.vendorName, index),
		tableCell(resolveCategory(value.offerCategory), index),
		tableCell(value.offerName, index),
		tableCell(formatOfferZip(value.offerZip), index),
		tableCell(translate(`admin.pages.agents.view.table.${status}`), index),
		tableCell(callback(value.id), index),
	];
}

/**
 * @param {string} offerZip
 * @returns {string}
 */
function formatOfferZip(offerZip) {
	const postalCodes = parsePostalCodeList(offerZip);

	if (postalCodes.length <= 3) {
		return postalCodes.join(', ') || offerZip;
	}

	return `${postalCodes.slice(0, 3).join(', ')}, ...`;
}

/**
 * @param {Data} data
 * @param {number} index
 * @returns {Response}
 */
function tableCell(data, index) {
	return { data, index: `vendor-${index}` };
}

/**
 * @param {string} category
 * @returns {string}
 */
function resolveCategory(category) {
	// @ts-ignore category can potentially not be in JSON category list
	return categoryList[category] ?? category;
}
